import React from "react";
import { MdCancel } from "react-icons/md";
const ChangeLogModal = ({ isOpen, onClose, changeLogID, logData }) => {
  if (!isOpen) return null;

  const changeLogEntries = logData
    ? Object.entries(logData).map(([field, entry]) => {
        // Log the oldData, newData, and changedData to the console
        console.log(`Field: ${field}`);
        console.log(`Old Data: ${entry.OldData}`);
        console.log(`New Data: ${entry.NewData}`);
        console.log(`Changed: ${entry.ChangedData}`);

        return {
          field,
          oldData: entry.OldData,
          newData: entry.NewData,
          changedData: entry.ChangedData,
          createdAt: entry.CreatedAt
            ? new Date(entry.CreatedAt).toLocaleString()
            : "N/A",
        };
      })
    : [];

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75 z-50">
      <div className="bg-white w-full md:w-3/4 p-8 pt-4 rounded-lg shadow-2xl overflow-y-auto max-h-[90%]">
        {/* Modal Header with Booking ID */}
        <div className="flex justify-between items-center mb-6 sticky top-0 z-10">
          <h2 className="text-xl font-semibold text-gray-900 text-center w-full"></h2>
          <button onClick={onClose}>
            <MdCancel className="h-8 w-8 text-red-500 hover:text-red-700 transition-colors duration-300" />
          </button>
        </div>

        {/* Change Log Entries */}
        {changeLogEntries.length > 0 &&
          changeLogEntries.map((entry, index) => (
            <div
              key={index}
              className="mb-8 p-6 rounded-lg bg-gray-50 shadow-md"
            >
              {/* Location and Timestamp */}
              <div className="text-center mb-4">
                <h3 className="text-lg font-semibold text-gray-800">
                  Updated At: {entry.createdAt}
                </h3>
              </div>

              {/* Data Table */}
              <div className="overflow-x-auto">
                <table className="min-w-full table-auto border-collapse">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border p-3 text-left text-sm font-medium text-gray-700">
                        Old Data
                      </th>
                      <th className="border p-3 text-left text-sm font-medium text-gray-700">
                        New Data
                      </th>
                      <th className="border p-3 text-left text-sm font-medium text-gray-700">
                        Changed
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      key={index}
                      className="hover:bg-gray-100 transition-colors duration-150"
                    >
                      <td className="border p-3 text-sm text-gray-800">
                        {/* {entry.oldData} */}
                        <ChangeLogTable dataString={entry.oldData} />
                      </td>
                      {/* <td className="border p-3 text-sm text-gray-800">{entry.newData}</td> */}
                      <td className="border p-3 text-sm text-gray-800">
                        <ChangeLogTable dataString={entry.newData} />{" "}
                      </td>

                      <td className="border p-3 text-sm items-start justify-start text-gray-800 align-top">
                        <ChangeLogTable dataString={entry.changedData} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ChangeLogModal;

const ChangeLogTable = ({ dataString }) => {
  // Replace single quotes with double quotes, '' with null, and datetime.date with a date string
  const jsonString = dataString
    .replace(/'/g, '"') // Replace single quotes with double quotes
    .replace(/''/g, "null") // Replace '' with null
    .replace(/datetime\.date\((\d{4}), (\d{2}), (\d{2})\)/g, '"$1-$2-$3"'); // Replace datetime.date with a proper string format

  // Parse the corrected JSON string to an object
  let parsedData;
  try {
    parsedData = JSON.parse(jsonString);
  } catch (e) {
    console.error("Error parsing JSON:", e);
    return <p>Error parsing data.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto border-collapse">
        <thead className="bg-gray-100">
          <tr>
            <th className="border p-3 text-left text-sm font-medium text-gray-700">
              Field
            </th>
            <th className="border p-3 text-left text-sm font-medium text-gray-700">
              Value
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(parsedData)
            .filter(([key, value]) => value !== null && value !== "") // Filter out null or empty values
            .map(([key, value], index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 transition-colors duration-150"
              >
                <td className="border p-3 text-sm text-gray-800">{key}</td>
                <td className="border p-3 text-sm text-gray-800">
                  {value !== null ? value.toString() : "N/A"}{" "}
                  {/* Handling null values */}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
